import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	body: {
		maxHeight: 'calc(100vh - 240px)',
		overflowY: 'auto',
	},
});
